import { mapContact, mapLinkableEntityType } from '@api';
import type { CompanyArtistContactType as ApiCompanyArtistContactType } from 'src/api/generated/touring/types';
import type { CompanyArtistContactType } from '../../types';

export const mapCompanyArtistContactType = (
  api: ApiCompanyArtistContactType
): CompanyArtistContactType => ({
  category: api.category,
  person: mapLinkableEntityType(api.person),
  contact: api.contact ? mapContact(api.contact) : null,
});
